import React, { useState, useRef } from "react";
import styles from "./SelloManager.module.css";

const STORAGE_KEY = "siisc_sellos_guardados";

// ── Helpers de localStorage ──────────────────────────────────────────────────
export const getSellosGuardados = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

const saveSellos = (sellos) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sellos));
};

// ── Componente ────────────────────────────────────────────────────────────────
const SelloManager = ({ onClose }) => {
  const [sellos, setSellos] = useState(getSellosGuardados);
  const [nombre, setNombre] = useState("");
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setPreview(ev.target.result);
    reader.readAsDataURL(file);
    setError("");
  };

  const handleGuardar = () => {
    if (!nombre.trim()) { setError("Ponle un nombre al sello."); return; }
    if (!preview)        { setError("Selecciona una imagen primero."); return; }

    const nuevo = { id: Date.now(), nombre: nombre.trim(), base64: preview };
    const actualizados = [...sellos, nuevo];
    saveSellos(actualizados);
    setSellos(actualizados);
    setNombre("");
    setPreview(null);
    setError("");
    if (inputRef.current) inputRef.current.value = null;
  };

  const handleEliminar = (id) => {
    const actualizados = sellos.filter((s) => s.id !== id);
    saveSellos(actualizados);
    setSellos(actualizados);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* HEADER */}
        <div className={styles.header}>
          <h2 className={styles.headerTitle}>🖋️ Mis Sellos Guardados</h2>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.body}>
          {/* FORMULARIO PARA AGREGAR */}
          <div className={styles.addSection}>
            <p className={styles.addTitle}>Agregar nuevo sello</p>
            <p className={styles.hint}>
              PNG con fondo transparente recomendado. Una vez guardado podrás reutilizarlo en cualquier firma.
            </p>

            <div className={styles.row}>
              <input
                className={`${styles.nameInput} ${preview && !nombre.trim() ? styles.nameInputAlert : ""}`}
                type="text"
                placeholder="Escribe un nombre para el sello..."
                value={nombre}
                onChange={(e) => { setNombre(e.target.value); setError(""); }}
                maxLength={60}
              />
              <button
                className={styles.uploadBtn}
                onClick={() => inputRef.current?.click()}
              >
                📎 Seleccionar imagen
              </button>
              <input
                ref={inputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>

            {/* Hint cuando hay imagen pero falta el nombre */}
            {preview && !nombre.trim() && (
              <div className={styles.alertHint}>
                ⚠️ <strong>Falta el nombre:</strong> escribe cómo quieres llamar a este sello para poder guardarlo.
              </div>
            )}

            {preview && (
              <div className={styles.previewBox}>
                <img src={preview} alt="Vista previa" className={styles.previewImg} />
                <span className={styles.previewLabel}>Vista previa — imagen lista ✅</span>
              </div>
            )}

            {error && <p className={styles.error}>{error}</p>}

            <button
              className={styles.saveBtn}
              onClick={handleGuardar}
              disabled={!preview || !nombre.trim()}
              title={!preview ? "Selecciona una imagen primero" : !nombre.trim() ? "Escribe un nombre para el sello" : ""}
            >
              {(!preview || !nombre.trim()) ? "💾 Guardar sello (completa los campos)" : "💾 Guardar sello"}
            </button>
          </div>

          {/* LISTA DE SELLOS GUARDADOS */}
          <div className={styles.listSection}>
            <p className={styles.listTitle}>
              Sellos disponibles ({sellos.length})
            </p>

            {sellos.length === 0 ? (
              <div className={styles.empty}>
                <span>📭</span>
                <p>No hay sellos guardados aún. Agrega uno arriba.</p>
              </div>
            ) : (
              <div className={styles.grid}>
                {sellos.map((s) => (
                  <div key={s.id} className={styles.selloCard}>
                    <img src={s.base64} alt={s.nombre} className={styles.selloImg} />
                    <p className={styles.selloName}>{s.nombre}</p>
                    <button
                      className={styles.deleteBtn}
                      onClick={() => handleEliminar(s.id)}
                      title="Eliminar"
                    >
                      🗑️ Eliminar
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelloManager;
